
    <div class="row"> 
        <table class="medio-verificacion">
            <tr>
                <th>PROGRAMA</th>
                <th>NO INICIADOS</th>
                <th>% NO INICIADOS</th>
                <th>INICIADOS</th>
                <th>% INICIADOS</th>
                <th>TERMINADOS</th>
                <th>% TERMINADOS</th>
                <th>TOTAL</th>
            </tr>
            <tr *ngFor="let programa of resumenPrograma; let v = index">
                <td>{{programa.agrupador}}</td>
                <td>{{programa.noIniciados}}</td>
                <td>{{(programa.noIniciados * 100) / programa.total | number:'1.0-0'}}%</td>
                <td>{{programa.iniciados - programa.terminados}}</td>
                <td>{{((programa.iniciados - programa.terminados) * 100) / programa.total | number:'1.0-0'}}%</td>
                <td>{{programa.terminados}}</td>
                <td>{{(programa.terminados * 100) / programa.total | number:'1.0-0'}}%</td>
                <td>{{programa.total}}</td>
            </tr>
        </table>
    </div>

    <div class="mt-4 mb-3" style="border-bottom: 2px solid #597CEE;width: 100%;"></div>

<div class="row"> 
   
    <table class="medio-verificacion mt-2">
        <tr>
            <th>REGIÓN</th>
            <th>NO INICIADOS</th>
            <th>INICIADOS</th>
            <th>TERMINADOS</th>
            <th>TOTAL</th>
        </tr>
        <tr *ngFor="let region of resumenRegion; let v = index">
            <td>{{region.agrupador}}</td>
            <td>{{region.noIniciados}}</td>
            <td>{{region.iniciados - region.terminados}}</td>
            <td>{{region.terminados}}</td>
            <td>{{region.total}}</td>
        </tr>
    </table>

</div>



<ngx-spinner></ngx-spinner>